// ==UserScript==// @name  Script Widget Genesys
// @namespace
// @version      	0.1
// @description  	Configuration liee au site SAMY
// @environnement 	DEV
// @author       	Ceritek
// @match
// @grant        	none

/***************************************************/
// Host et port à configurer
const WidgetsReglesEngagement = {
	//chat
	GroupAgentsChatStats: "DVA_CHAT_ORGANIGRAMME_TITULAIRE",
	FileChatStats: "CHAT DVA_CLI_ORGANIGRAMME@Switch_Multimedia",
	NbMinAgentsChats: "1",
	// NbMinAgentsChats: process.env.NODE_ENV === "production" ? "2" : "1",
	NbMaxChatAttente: "10",
	activation_chat: "1",
	//callback
	GroupAgentsCallbackStats: "DVA_CHAT_ORGANIGRAMME_TITULAIRE",
	FileCallbackStats: "CHAT DVA_CLI_ORGANIGRAMME@Switch_Multimedia",
	NbMinAgentsCallback: "1",
	NbMaxWcbAttente: "10",
	NbMaxCallbackAttente: "10",
	activation_wcb: "1",
	activation_ctm: "1",
	//general
	SeuilMaxAttente: "300",
	statsPourActivation: "Log", //versus 'Pret'
	scenario: "1", //scenario 1: chat only //scenario 2: chat et WCB //scenario 3: chat et WCB et CTM //scenario 4: WCB et CTM //scenario 5: CTM //scenario 6: Chat et CTM //scenario 7: WCB
};

export default WidgetsReglesEngagement;



// WEBPACK FOOTER //
// ./genesys/widgets/conf/GEN_Organigramme_RE.js